import { TranslationService } from '../../../shared/translation/translation.service';
import { ConfirmationService } from 'primeng/api';
import { CertificationEditDialogComponent } from '../../../certification/certification-edit-dialog/certification-edit-dialog.component';
import { ObservationService } from '../../../shared/observation/observation.service';
import { UtilService } from '../../../shared/util/util.service';
import { CeuEditDialogComponent } from '../../../certification/ceu-edit-dialog/ceu-edit-dialog.component';
import { CertificationActivitySearchDto } from '../../../certification/shared/certification-activity-search.dto';
import { CertificationActivityService } from '../../../certification/shared/certification-activity.service';
import { PagedResultGeneric } from 'src/app/shared';
import { ProfileCertificationTypeDto } from '../../shared/dto/profile-certification-type.dto';
import { ProfileCertificationService } from '../../shared/profile-certification.service';
import { Component, OnInit, SimpleChanges, OnChanges, Input, ElementRef, ViewChild } from '@angular/core';
import { CertificationActivityDto } from 'src/app/certification/shared/dto/certification-activity.dto';
import { EventsService } from 'src/app/events/shared/events.service';
import { EventSearchParams } from 'src/app/events/search/event-search-params.model';
import { AttendeeService } from 'src/app/events/attendee/shared/attendee.service';
import { AttendeeSearchParams } from 'src/app/events/attendee/shared/attendee-search-params.model';
import { ProfileService } from '../../shared/profile.service';
import { result } from 'lodash-es';
import { EventRead } from 'src/app/events/shared/event-read.model';
import { UserService } from 'src/app/users/shared/user.service';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';

@Component({
  selector: 'wl-profile-view-certifications',
  templateUrl: './profile-view-certifications.component.html',
  styleUrls: ['./profile-view-certifications.component.less'],
  providers: [AttendeeService],
    standalone: false
})
export class ProfileViewCertificationsComponent implements OnInit, OnChanges {
  @Input() profileId: number;
  @ViewChild(CeuEditDialogComponent) ceuDialog: CeuEditDialogComponent;
  @ViewChild(CertificationEditDialogComponent) certDialog: CertificationEditDialogComponent;

  public certifications: Array<ProfileCertificationTypeDto>;
  public certificationActivities: PagedResultGeneric<CertificationActivityDto>;
  public today = new Date();
  public rejectText = '';
  public acceptText = '';
  private profileEventAttendees: Array<any>;
  profileModuleFullAccess: boolean = false;

  public constructor(
    private _profileCertificationService: ProfileCertificationService,
    private _certificationActivityService: CertificationActivityService,
    private _eventService: EventsService,
    private _profileService: ProfileService,
    private ref: ElementRef,
    private _utilService: UtilService,
    private _observationService: ObservationService,
    private _confirmationService: ConfirmationService,
    private _translationService: TranslationService,
    private _userService: UserService
  ) {}

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Profiles_Module').then((userAccessLevel: number) => {
      this.profileModuleFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileId) {
      this.loadCertifications(1, true);

      this._observationService.observeProfiles().subscribe((id) => {
        if (id === this.profileId) {
          this.loadCertifications(1, true, true);
        }
      });
    }
  }

  public onPagingEvent(page: number) {
    this.loadCertifications(page, false, true);
  }

  public loadCertifications(page: number, isInitialLoad: boolean, forceRefresh?: boolean) {
    const activitySearch = new CertificationActivitySearchDto();
    activitySearch.ProfileId = this.profileId;
    activitySearch.PageSize = 10;
    activitySearch.IncludeCE_CreditType = true;
    activitySearch.IncludeCertificationActivitySource = true;
    activitySearch.ActivityType = 3;
    activitySearch.PageNumber = page;

    this._profileCertificationService
      .getProfileCertifications(this.profileId)
      .then((data: PagedResultGeneric<ProfileCertificationTypeDto>) => {
        this.certifications = data.Result;
      });

    this._certificationActivityService
      .getCEUsEarnedForProfileId(activitySearch, forceRefresh ?? false)
      .then((data: PagedResultGeneric<CertificationActivityDto>) => {
        data.Result.forEach((certificationActivity) => {
          if (certificationActivity.EventAttendeeID != 0 && certificationActivity.EventAttendeeHeaderID != 0) {
            this.getProfileEventAttendees(certificationActivity);
          }
        });
        this.certificationActivities = data;
      });

    const element = this.ref.nativeElement;

    if (!isInitialLoad) {
      window.scrollTo(window.scrollX, element.offsetTop + 50);
    }
  }

  public getProfileEventAttendees(certificationActivity: CertificationActivityDto) {
    this._profileService.getProfileEventAttendees(this.profileId).then((result) => {
      this.profileEventAttendees = result;
      let attendee = this.profileEventAttendees.find((attendee) => attendee.AttendeeId == certificationActivity.EventAttendeeHeaderID);
      this.getEvent(attendee.EventId, certificationActivity);
    });
  }

  public getEvent(eventId: number, certificationActivity: CertificationActivityDto) {
    this._eventService.getEventRead(eventId).then((event) => {
      event != null ? (certificationActivity.EventName = event.EventName) : (certificationActivity.EventName = '');
    });
  }

  public editCEU(activity: CertificationActivityDto) {
    this.ceuDialog.activity = this._utilService.clone(activity);
    this.ceuDialog.show = true;
  }

  public addNewCeu() {
    this.ceuDialog.activity = { ProfileId: this.profileId, ActivityDate: new Date(), ActivityType: 3 } as CertificationActivityDto;
    this.ceuDialog.show = true;
  }

  public deleteCEU(id: number) {
    this.rejectText = this._translationService.getInstant('profiles.view.certifications.cancel').toUpperCase();
    this.acceptText = this._translationService.getInstant('profiles.view.certifications.delete-ceu-button').toUpperCase();

    this._confirmationService.confirm({
      header: this._translationService.getInstant('profiles.view.certifications.delete-this-ceu'),
      message: this._translationService.getInstant('profiles.view.certifications.delete-ceu-body'),
      accept: () => {
        this._certificationActivityService.delete(id).then(() => {
          this.loadCertifications(1, true, true);
        });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }

  public editCertification(cert: ProfileCertificationTypeDto) {
    this.certDialog.certification = this._utilService.clone(cert);
    this.certDialog.show = true;
  }

  public addNewCertification() {
    this.certDialog.certification = { ProfileId: this.profileId, CertificationDate: new Date() } as ProfileCertificationTypeDto;
    this.certDialog.show = true;
  }

  public deleteCertification(id: number) {
    this.rejectText = this._translationService.getInstant('profiles.view.certifications.cancel').toUpperCase();
    this.acceptText = this._translationService.getInstant('profiles.view.certifications.delete-certification-button').toUpperCase();

    this._confirmationService.confirm({
      header: this._translationService.getInstantTitlecase('profiles.view.certifications.delete-this-certification'),
      message: this._translationService.getInstantCapitalizeFirstCharacter('profiles.view.certifications.delete-certification-body'),
      accept: () => {
        this._profileCertificationService.delete(id).then(() => {
          this.loadCertifications(1, true, true);
        });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
